import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { HomePage } from './routes/HomePage';
import { EssaysIndex } from './routes/EssaysIndex';
import { EssayPage } from './routes/EssayPage';
import { DispatchesIndex } from './routes/DispatchesIndex';
import { DispatchPage } from './routes/DispatchPage';
import { NotFound } from './routes/NotFound';

// Admin routes are lazy-loaded so public visitors don't download the CMS
// bundle (forms, markdown editor, auth flow) they'll never use.
const AdminLayout = lazy(() =>
  import('./routes/admin/AdminLayout').then((m) => ({ default: m.AdminLayout }))
);
const AdminDashboard = lazy(() =>
  import('./routes/admin/AdminDashboard').then((m) => ({ default: m.AdminDashboard }))
);
const PostsList = lazy(() =>
  import('./routes/admin/PostsList').then((m) => ({ default: m.PostsList }))
);
const PostEdit = lazy(() =>
  import('./routes/admin/PostEdit').then((m) => ({ default: m.PostEdit }))
);
const NowEditor = lazy(() =>
  import('./routes/admin/NowEditor').then((m) => ({ default: m.NowEditor }))
);
const CircuitEditor = lazy(() =>
  import('./routes/admin/CircuitEditor').then((m) => ({ default: m.CircuitEditor }))
);
const CompaniesEditor = lazy(() =>
  import('./routes/admin/CompaniesEditor').then((m) => ({ default: m.CompaniesEditor }))
);
const YakitoriEditor = lazy(() =>
  import('./routes/admin/YakitoriEditor').then((m) => ({ default: m.YakitoriEditor }))
);
const IdeasEditor = lazy(() =>
  import('./routes/admin/IdeasEditor').then((m) => ({ default: m.IdeasEditor }))
);
const SubscribersEditor = lazy(() =>
  import('./routes/admin/SubscribersEditor').then((m) => ({ default: m.SubscribersEditor }))
);
const DispatchEditor = lazy(() =>
  import('./routes/admin/DispatchEditor').then((m) => ({ default: m.DispatchEditor }))
);
const TokenManager = lazy(() =>
  import('./routes/admin/TokenManager').then((m) => ({ default: m.TokenManager }))
);

function AdminSuspenseGate() {
  return (
    <Suspense fallback={<div className="admin-loading">loading admin…</div>}>
      <AdminLayout />
    </Suspense>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/essays" element={<EssaysIndex />} />
      <Route path="/essays/:slug" element={<EssayPage />} />
      <Route path="/dispatches" element={<DispatchesIndex />} />
      <Route path="/dispatches/:slug" element={<DispatchPage />} />
      <Route path="/admin" element={<AdminSuspenseGate />}>
        <Route index element={<AdminDashboard />} />
        <Route path="posts" element={<PostsList />} />
        <Route path="posts/new" element={<PostEdit />} />
        <Route path="posts/:id" element={<PostEdit />} />
        <Route path="dispatch" element={<DispatchEditor />} />
        <Route path="ideas" element={<IdeasEditor />} />
        <Route path="subscribers" element={<SubscribersEditor />} />
        <Route path="now" element={<NowEditor />} />
        <Route path="circuit" element={<CircuitEditor />} />
        <Route path="companies" element={<CompaniesEditor />} />
        <Route path="yakitori" element={<YakitoriEditor />} />
        <Route path="tokens" element={<TokenManager />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
